<footer class="tui_row footer justify-center">
  {{ currentYear }} &copy; All rights reserved. {{ env?.platform?.company }}.
</footer>
